import React from "react";
import ReactDOM from "react-dom";
interface Props {
	children?: React.ReactNode;
}

function WorkbenchLayer({ children }: Props) {
	const portal = document.getElementById("workbench");
	if (!portal) return null;
	return ReactDOM.createPortal(
		<div className="workbench-layer">
			<div className="workbench-content">{children}</div>
		</div>,
		portal
	);
}

export default WorkbenchLayer;
